import React from 'react';
import axios from 'axios';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import validator from 'validator';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//styles
import './login.styl';
import './Recover.styl';
import 'bootstrap/dist/css/bootstrap.css';
//text
//config
const baseUrl = require('Config').baseUrl;
class Recover extends React.Component {
  constructor(props){
    super(props);

    const captcha = this.generateCaptcha();
    this.state = {
      email: '',
      popupText: 'Processing. Just a moment...',
      captchaQuestion: captcha.question,
      captchaAnswer: captcha.answer,
      userCaptchaAnswer: ''
    }
  }

  generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    return {
      question: `What is ${num1} + ${num2}?`,
      answer: num1 + num2
    };
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  validate = () => {
  	this.setState({email: validator.escape(this.state.email)});
  	let isEmail = validator.isEmail(this.state.email);
  	return isEmail;
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({popupText: 'Just a moment...'});

    const url = `${baseUrl}/users/recover`;

    // Validate captcha first
    if(parseInt(this.state.userCaptchaAnswer) !== this.state.captchaAnswer){
      const newCaptcha = this.generateCaptcha();
      this.setState({
        popupText: 'Incorrect captcha answer. Please try again.',
        captchaQuestion: newCaptcha.question,
        captchaAnswer: newCaptcha.answer,
        userCaptchaAnswer: ''
      });
      return;
    }

    if(this.validate()){
	    axios.post(url, {
	    	email: this.state.email,
	    })
	    .then(response => {
	      this.setState({popupText: 'Recovery email has been sent!'});
	    })
	    .catch(err => {
	      this.setState({popupText: 'User with this email does not exist.'});
	    });
    }
    else {
    	this.setState({popupText: 'Please, provide a valid email'});
    }
  }

  popup = () => {
    return (
      <Tooltip className="in" id="tooltip-top">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  render(){
    return (
      <SimpleContainer color='white' containerClass='padded-container form-container'>
	      <div className='recover-form-wrapper login-form-wrapper'>
		      <form className='recover-form form-body' onSubmit={this.submitForm}>
            <div className="form__input-field">
              <label htmlFor="email" className='form-text'>email<sup>*</sup></label>
              <input id="email" type='email' name='email' className='input email' placeholder='example@company.com' value={this.state.email} onChange={this.inputChange}/>
            </div>
            <div className="form__input-field">
              <label htmlFor="captcha" className='form-text'>{this.state.captchaQuestion}<sup>*</sup></label>
              <input id="captcha" type='number' name='userCaptchaAnswer' className='input captcha' placeholder='Enter answer' value={this.state.userCaptchaAnswer} onChange={this.inputChange} required/>
            </div>
            <p>We will send you an email to the provided address with the reset instructions <span className='highlight'>address must be registered with aircheckr (if you did not receive one, check spam folder)</span></p>
            <div className="right-align">
  		        <OverlayTrigger className='form-overlay' trigger={'focus'} placement="bottom" overlay={this.popup()}>
  		          <button type="submit" className="button">Submit</button>
  		        </OverlayTrigger>
            </div>
		      </form>
	      </div>
	  </SimpleContainer>
    );
  }
};

export default Recover;



// WEBPACK FOOTER //
// ./src/routes/Recover.js